import { IPlayerSegmentationData } from "@sparkware/uc-sdk-core";
import { put } from "redux-saga/effects";
import { segmentationUpdate } from "../../../../actions";

export function* dispatchSegmentationUpdate(data: IPlayerSegmentationData) {
  yield put(segmentationUpdate(data));
}
